import { css } from '@emotion/core';
export default (lines => /*#__PURE__*/css("overflow:hidden;-webkit-line-clamp:", lines, ";display:-webkit-box;-webkit-box-orient:vertical;overflow-wrap:break-word;"));